import { type FC, type ReactElement } from "react";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { useSelectedOrganization } from "../../organizations/hooks";
import { useLensSourceTypes } from "../hooks";

interface LensSourceTypesContainerAPI {
    types: readonly LensSourceType[];
    loading: boolean;
}

interface LensSourceTypesContainerProps {
    children: (api: LensSourceTypesContainerAPI) => ReactElement;
}

const PermittedLensSourceTypesContainer: FC<LensSourceTypesContainerProps> = ({ children }) => {
    const { loading, types } = useLensSourceTypes();

    return children({ loading, types });
};

export const LensSourceTypesContainer: FC<LensSourceTypesContainerProps> = ({ children }) => {
    const { permissions } = useSelectedOrganization();

    if (!permissions?.readLensSources) {
        // when there is no permission to read lens source,
        // just return an empty list
        return children({
            loading: false,
            types: [],
        });
    }

    return <PermittedLensSourceTypesContainer children={children} />;
};
